import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'

import homeRoutes from '@/libs/home/routes';
import userSettingsRoutes from '@/libs/user-settings/routes';
import authentificationRoutes from '@/libs/auth/routes';
import dashboardRoutes from '@/libs/dashboard/routes';
import catalogueItemsRoutes from '@/libs/catalogue-items/routes';
import workTasksRoutes from '@/libs/work-tasks/routes';
import partiesRoutes from '@/libs/parties/routes';
import statementsRoutes from '@/libs/statements/routes';
import settingsRoutes from '@/libs/settings/routes';
import reportsRoutes from '@/libs/reports/routes';
import cloudRoutes from '@/libs/cloud/routes';
import workTaskRulesRoutes from '@/libs/work-task-rules/routes';
import visitRulesRoutes from '@/libs/visit-rules/routes';
import clientsEvaluationsRoutes from '@/libs/clients-evaluation/routes';
import billingRoutes from '@/libs/billings/routes';
import closingRoutes from '@/libs/closings/routes';
import adminRoutes from '@/libs/admin/routes';

Vue.use(VueRouter)

const baseRoutes = [
    
] as RouteConfig[];

const routes: RouteConfig[] = [
    ...baseRoutes,
    ...homeRoutes,
    ...dashboardRoutes,
    ...catalogueItemsRoutes,
    ...workTasksRoutes,
    ...authentificationRoutes,
    ...partiesRoutes,
    ...statementsRoutes,
    ...settingsRoutes,
    ...userSettingsRoutes,
    ...reportsRoutes,
    ...cloudRoutes,
    ...workTaskRulesRoutes,
    ...visitRulesRoutes,
    ...clientsEvaluationsRoutes,
    ...billingRoutes,
    ...closingRoutes,
    ...adminRoutes
]

const router = new VueRouter({
    routes
})

export default router
